import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Spinner from '../common/spinner';

//CUSTOM COMPONENTS
import DataTable from '../common/datatable';

const notcolums =[
    {
        name:'#',
        type:'text',
        label:'id',
        minWidth:'520'
    },
    {
        name:'Noticia',
        type:'text',
        label:'titulo',
        minWidth:'0'
    },
    {
        name:'Categoría',
        type:'text',
        label:'categoria',
        minWidth:'640',
    },
    {
        name:'Fecha',
        type:'text',
        label:'fechasrt',
        minWidth:'470',
    },
    {
        name:'Estatus',
        type:'text',
        label:'estatus',
        minWidth:'729'
    },
    {
        name:'Editar',
        type:'custom',
        label:e=>{
            return(
                <Link className="btn btn-warning" to={`/editor/noticia/${e.id}`} >Editar</Link>
            )
        }
    }
]

const blogcolums =[
    {
        name:'#',
        type:'text',
        label:'id',
        minWidth:'520'
    },
    {
        name:'Artículo',
        type:'text',
        label:'titulo'
    },
    {
        name:'Categoría',
        type:'text',
        label:'categoria',
        minWidth:'640',
    },
    {
        name:'Fecha',
        type:'text',
        label:'fechasrt',
        minWidth:'470',
    },
    {
        name:'Estatus',
        type:'text',
        label:'estatus',
        minWidth:'729'
    },
    {
        name:'Editar',
        type:'custom',
        label:e=>{
            return(
                <Link className="btn btn-warning" to={`/editor/articulo/${e.id}`} >Editar</Link>
            )
        }
    }
]

const Inicio = () => {
    const [noticias,setNoticias] = useState([]);
    const [articulos,setArticulos] = useState([]);

    //CONSULTAR NOTICIAS
    const getNoticias = async () =>{
        let response = await fetch('/p_noticias', {
            method: 'POST',
            body: JSON.stringify({}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            console.log('NOTICIAS',res);
            let com = [];
            res.resultado[0].map((e,i)=>{
                let a = new Date(e.fecha);
                let b = new Date();
                console.log(a,b);
                
                if( !e.estatus || a>b ){
                    e.fechasrt=new Date(e.fecha).toLocaleDateString();
                    e.estatus=e.estatus?'Publico':'Oculto';
                    com.push(e)
                }
            })
            setArticulos(com);
        }
        catch{
            
        }
    }
    const getArticulos = async () =>{
        let response = await fetch('/p_articulos', {
            method: 'POST',
            body: JSON.stringify({}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            console.log('ARTICULOS',res);
            let com = [];
            res.resultado[0].map((e,i)=>{
                let a = new Date(e.fecha);
                let b = new Date();
                console.log(a,b);
                
                if( !e.estatus || a>b ){
                    e.fechasrt=new Date(e.fecha).toLocaleDateString();
                    e.estatus=e.estatus?'Publico':'Oculto';
                    com.push(e)
                }
            })
            setArticulos(com);
        }
        catch{
            
        }
    }
    useEffect(() => {
        // getNoticias();
        // getArticulos();
    }, []);
    
    return (
        <Fragment>
            {/* <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 mt-3">
                        <div className="row">
                            <div className="col-sm-8"><h4>Inicio</h4></div>
                            <div className="col-sm-4 text-right">
                                
                            </div>
                        </div>
                    </div>
                <div className="col-sm-12 col-xl-12 xl-100">
                        <div className="card height-equal mt-2">
                            <div className="card-body">
                                <h5>Noticas sin publicar</h5>
                                <Spinner>
                                    <DataTable
                                        data={noticias}
                                        colums={notcolums}
                                        pagination={5}
                                        search="Buscar noticia..."
                                    />
                                </Spinner>
                            </div>
                        </div>
                        <div className="card height-equal mt-2">
                            <div className="card-body">
                                <h5>Artículos sin publicar</h5>
                                <Spinner>
                                    <DataTable
                                        data={articulos}
                                        colums={blogcolums}
                                        pagination={5}
                                        search="Buscar articulo..."
                                    />
                                </Spinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </Fragment>
    );
};

export default Inicio;